import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Typography,
} from '@mui/material'

import CustomModal from '../custom/CustomModal'
import CustomPdfViewer from '../custom/CustomPdfViewer'
import { filePreviewStyle } from '../../utils/constants'
import { isNotNullValue } from 'src/utils/formUtil'

export default function DocumentViewer({
  documentUrl,
  openModal,
  handleCloseModal,
}) {

  const [existsUrl, setExistsUrl] = useState({});
  const [modalStyle, setModalStyle] = useState({});

  useEffect(() => {
    const _exitsUrl = isNotNullValue(documentUrl);
    setExistsUrl(_exitsUrl);

    if (_exitsUrl) {
      setModalStyle({ ...filePreviewStyle });
    }
  }, [documentUrl]);

  return (
    <CustomModal
      openModal={openModal}
      handleCloseModal={handleCloseModal}
      modalTitle={`Preview Document`}
      modalIcon='document'
      modalStyle={modalStyle}
    >
      <Box
        sx={{
          my: 2,
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        {existsUrl ? (
          <CustomPdfViewer fileUrl={documentUrl} />
        ) : (
          <Typography variant='h6' color='error'>
            Unable to preview document!
          </Typography>
        )}
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'right', mt: 2 }}>
        <Button
          variant='contained'
          color="inherit"
          onClick={handleCloseModal}
        >
          Cancel
        </Button>
      </Box>
    </CustomModal>
  )
}
